const FROM_URL: Record<string, string> = {
  jpg: "jpg", jpeg: "jpg", png: "png", bmp: "bmp", webp: "webp", gif: "gif",
  mp4: "mp4", webm: "webm", ogg: "ogg", pdf: "pdf", doc: "doc", docx: "docx",
};

export function imageHasOriginalChoice(item: { mediaAssetId?: string; type?: string } | null | undefined): boolean {
  if (!item?.mediaAssetId) return false;
  const type = String(item.type || "").toLowerCase();
  return type === "" || type.startsWith("image/");
}

/** Name the saved file after the bytes being fetched. A HEIC upload's servable copy is JPEG. */
export function downloadFileExtension(type: string | undefined, url: string | undefined): string {
  let path = "";
  try { path = new URL(String(url || "")).pathname.toLowerCase(); }
  catch { path = String(url || "").split("?")[0].toLowerCase(); }
  const dot = path.lastIndexOf(".");
  const fromUrl = dot >= 0 ? FROM_URL[path.slice(dot + 1)] : "";
  if (fromUrl) return fromUrl;
  const mime = String(type || "").toLowerCase();
  if (mime === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return "docx";
  if (mime === "application/msword") return "doc";
  const subtype = mime.split("/").pop() || "";
  if (subtype === "heic" || subtype === "heif") return "heic";
  return subtype && subtype !== mime ? subtype : "jpg";
}
